export const defaultSynthMember = {
    name: "Synth",
    email: "hello@synth.com",
    image: "https://storage.googleapis.com/heysynth_files/synth_webapp/synthAllylogo_fhimzk.png",
};
